export * from './widgets-collection';